module.exports = __webpack_public_path__ + "media/images/icons/twotone/compass-6b54e1f764892b67f277d16d821e7e11.svg";